import '@grapecity/wijmo.styles/wijmo.css';
import './assets/css/bf-base.css';
import './assets/css/mui-custom.css';
import './assets/css/wijmo-custom.css';

import {createRoot} from 'react-dom/client';
import {connect, Provider as ReduxProvider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {IntlProvider} from 'react-intl';
import 'react-app-polyfill/ie11';
import ContainerRouter from './router';
import configureStore, {persistor} from './reducks/store';
import axios from 'axios';
import GlobalIntlProvider from './core/globalIntl';
import appConfig from '@/config';
import {PersistGate} from 'redux-persist/integration/react';
import * as wjcCore from '@grapecity/wijmo';
import '@grapecity/wijmo.cultures/wijmo.culture.ja';
import esriConfig from '@arcgis/core/config';
import { defineCustomElements } from '@arcgis/map-components/dist/loader';
import ErrorBoundary from './pages/ErrorBoundary';
import setupAxios from '@/core/axios';

// Wijmo ライセンスキー
wjcCore.setLicenseKey(appConfig.WIJMO_LICENSE_KEY);

// ArcGIS APIキー設定 & React 18 ラッパー設定
esriConfig.apiKey = appConfig.gis.apiKey;
defineCustomElements();

const reduxStore = configureStore(window.REDUX_INITIAL_DATA);

// 遅延実行関数
const debounce = (fn, delay) => {
  let timer;

  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

/**
 * "ResizeObserver loop completed with undelivered notifications."
 * エラー抑制のため、サイズ変更通知の頻度を抑制する
 */
window.ResizeObserver = class ResizeObserver extends window.ResizeObserver {
  constructor(callback) {
    super(debounce(callback, 100));
  }
};

let MainComponent = ({locale, messages}) => (
  <IntlProvider locale={locale} messages={messages}>
    <GlobalIntlProvider>
      <ContainerRouter />
    </GlobalIntlProvider>
  </IntlProvider>
);

MainComponent = connect((state) => ({
  locale: state.style.locale,
  messages: state.style.messages,
}))(MainComponent);

// 言語切り替えが実装したい場合は、local / messages を
// redux の store で管理するようにし、動的に入れ替える。
// Material-ui のテーマについても同様、Provider に与える
// テーマを事前に複数用意しておき、ユーザ操作によりその値
// を変更することで、複数パターンの動的テーマ切り替えを可能とする。

const root = createRoot(document.getElementById('root'));
root.render(
    <ReduxProvider store={reduxStore}>
      <ErrorBoundary>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <MainComponent/>
          </BrowserRouter>
        </PersistGate>
      </ErrorBoundary>
    </ReduxProvider>,
);

// axiosのタイムアウトを設定
if (appConfig.AXIOS_TIMEOUT != null) {
  axios.defaults.timeout = appConfig.AXIOS_TIMEOUT;
}

// Axios 要求インターセプター設定
axios.interceptors.request.use(
    setupAxios.requestInterceptor(reduxStore),
    setupAxios.requestErrorHandler(reduxStore));

// Axios 応答インターセプター設定
axios.interceptors.response.use(
    setupAxios.responseInterceptor(reduxStore),
    setupAxios.responseErrorHandler(reduxStore));

